import { Component, OnInit, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ModelService } from '../../../model.service';
import { Challenge } from "../../../classes/challenge";


@Component({
  selector: 'app-combine-challenges',
  templateUrl: './combine-challenges.component.html',
  styleUrls: ['./combine-challenges.component.css']
})
export class CombineChallengesComponent implements OnInit {

  challenges: Challenge[];

  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(private modelService: ModelService) { }

  ngOnInit() {
    this.visible = false;
    this.getChallenges();
  }

  getChallenges(): void {
    this.modelService.getChallenges().subscribe(challenges => {
      this.challenges = challenges;
      console.log('getting challenges to display');
      console.log(this.challenges);
      console.log(this.visible);
    }, err => {
      console.log("Error occured. dfdfd")
    });
  }

}



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/modal/combine/combine-challenges/combine-challenges.component.ts